module.exports = __webpack_public_path__ + "newstatic/img/iphone-b.3040365.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/iphone-b.png
// module id = EauK
// module chunks = 1